import { useState, useEffect } from 'react';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { arrayBufferToBase64 } from 'src/Admin/utils/common';

const useDocumentDetails = () => {
  const [getdocumentDetail, setGetDocumentDetail] = useState([]);
  const [loadingApiConfig, setLoadingApiConfig] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const documentdetail = location.state;
  const userSpecDoc = location.state.userSpecDoc;
  const dummyDocumentDetail = [
    { OrigFileName: 'Document_Name.pdf' },
    { OrigFileName: 'Document_Name.pdf' },
    { OrigFileName: 'Document_Name.pdf' },
  ];

  const documentDetails = async () => {
    if (documentdetail?.Source === 'JAVELINA') {
      const documentDetailsObj = {
        PDFLocation: documentdetail?.LocationOid,
        DocControlNo: documentdetail?.DocumentControlNumber,
        OrigFileName: documentdetail?.FileName,
      };
      setGetDocumentDetail([documentDetailsObj]);
      setLoadingApiConfig(false);
      return;
    }
    try {
      const responseDetails = await axiosInstance.get(
        APIEndpoints.getDocumentsDetail() + documentdetail?.Oid,
      );
      const documentDetailData =
        responseDetails.data.Response.documentDetailRespDTO;
      setGetDocumentDetail(documentDetailData);
      setLoadingApiConfig(false);
    } catch (error) {
      setLoadingApiConfig(false);
      if (error.toString().includes('400')) {
        setLoadingApiConfig(false);
      }
    }
  };

  const downloadFile = async (reportName, byte, contentType) => {
    const actualData = arrayBufferToBase64(byte);
    const link = document.createElement('a');
    link.setAttribute('href', `data:${contentType};base64,` + actualData);
    link.setAttribute('download', reportName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = (file) => async () => {
    console.log('debug_file', file);

    try {
      const docLocation = btoa(file.PDFLocation);
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getDocumentsDownload()}doclocation/${docLocation}/id/${
          file.DocControlNo
        }`,
        { responseType: 'arraybuffer' },
      );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(file.OrigFileName, responseDetails.data, contentType);
    } catch (err) {
      console.log('debug_err', err);
      return;
    }
  };

  const handleDownloadAll = (fileName, oid) => async () => {
    try {
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getAllDocumentsDownload()}uploadedbatchoid/${oid}`,
        { responseType: 'arraybuffer' },
      );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(`${fileName}.zip`, responseDetails.data, contentType);
    } catch (err) {
      return;
    }
  };

  /*const onClickBackButton = () => {
    navigate('/admin/view-member', {
      state: {
        documentDetailBackButton: true,
        ...location.state,
      },
    });
  }; */

  useEffect(() => {
    documentDetails();
  }, []);

  useEffect(() => {
    if (
      documentdetail === undefined &&
      getdocumentDetail &&
      getdocumentDetail.length <= 0
    ) {
      navigate('/admin/view-member');
    }
  }, [documentdetail, getdocumentDetail]);

  return {
    getdocumentDetail,
    loadingApiConfig,
    documentdetail,
    handleDownload,
    handleDownloadAll,
    userSpecDoc,
    dummyDocumentDetail,
  };
};

export default useDocumentDetails;
